import GAME_IDS from 'a/hub/data/GameIds';

export const CONTENT_VERSION = '0.1.1';
export const GAME_ID = GAME_IDS.CONNECT_IT;

// the percentage of items a user must correctly answer in a round to be considered
// as "mastering" content
export const PERCENTAGE_TO_MASTER = 78;

export const PRACTICE_ITEMS_PER_SET = 4;

export const SCREENS = {
  PROGRESS: `${GAME_ID}/progress`,
  LOADING: `${GAME_ID}/loading`,
  STANDARD: `${GAME_ID}/standard`,
  INSTRUCTION: `${GAME_ID}/instruction`,
  PRACTICE: `${GAME_ID}/practice`,
};

export const ITEM_STATE = {
  CORRECT: `${GAME_ID}/correct`,
  INCCORRECT: `${GAME_ID}/incorrect`,
  CURRENT: `${GAME_ID}/current`,
};

export const CONNECTIVE_COLORS = {
  BLUE: 'lightblue',
  YELLOW: 'palegoldenrod',
  PURPLE: 'plum',
  GRAY: 'lightgray',
  DEFAULT: 'lightgray',
};

// validation expresion for string that contains ]] means it contains reveal words.
export const regexRevealWord = /(\]]*){2,}/;

export const ROBO_VOICE_FILE_MAX_WORDS = 5;
